import { getToken } from '../getAccessToken';
import { User, Presence, UserStatus } from '../@chatscope/use-chat/src';
import { IPublicClientApplication } from "@azure/msal-browser";

import defaultAvatar from "../assets/Avatar.png";

export const getUserData = async (instance:IPublicClientApplication, upn: string): Promise<User> => {
    try {
        if (!upn) {
            throw new Error("[getUser] upn passed into function was null, empty, or undefined.");
        }

        var peopleApiUrl = `${process.env.REACT_APP_GRAPH_API}users/${upn.toUpperCase()}?&$select=onPremisesSamAccountName,displayName,userPrincipalName,givenName,surname,displayName,mail`;
        var scope = process.env.REACT_APP_GRAPH_API_SCOPE;
        var token = await getToken(instance, scope);

        const response = await fetch(peopleApiUrl, {
            method: 'GET',
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + token,
                'ConsistencyLevel': 'eventual'
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        let currentUserData = await response.json();

        let userObj = new User({
            id: currentUserData.userPrincipalName.substring(0, 6),
            presence: new Presence({ status: UserStatus.Unknown, description: "" }),
            firstName: currentUserData.givenName,
            lastName: currentUserData.surname,
            username: currentUserData.displayName,
            upn: currentUserData.userPrincipalName,
            avatar: await getUserPhoto(instance, currentUserData.userPrincipalName),
            bio: ""
        })

        const data = userObj;
        return data;

    } catch (error) {
        console.log(`An error occurred while trying to fetch the user properties for: ${upn}. The error is: ${error}`);
        throw error;
    }
}


export const getUsersData = async (instance:IPublicClientApplication, value: any): Promise<any> => {
    try {
        if (!value) {
            throw new Error("[getUsersData] Search string passed into function was null, empty, or undefined.");
        }

        var peopleApiUrl = process.env.REACT_APP_PEOPLE_SEARCH_API_URL?.replace(/{searchTerm}/g, value).replace("??","?$").replace(/&&/g,"&$");

        if (!peopleApiUrl) {
            throw new Error("[getUsersData] REACT_APP_PEOPLE_SEARCH_API_URL is not defined");
        }

        var scope = (process.env.REACT_APP_PEOPLE_API_SCOPE as string).trim();

        //this is temp until we find a way to include single quotes in pipeline env vars
        if (scope.includes("People.Read.All")){
            peopleApiUrl += "&$filter=personType/class eq 'Person' and personType/subclass eq 'OrganizationUser'";
        }

        var token = await getToken(instance, scope);

        const response = await fetch(peopleApiUrl, {
            method: 'GET',
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + token,
                'ConsistencyLevel': 'eventual' 
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data.value;

    } catch (error) {
        console.log(`An error occurred while trying to fetch user properties for: ${value}. The error is: ${error}`);
        throw error;
    }
}

export const getUserPhoto = async (instance:IPublicClientApplication, upn: string): Promise<string> => {
    try {
        if (upn === undefined || upn === null || upn === "") {
            throw new Error("[getUserPhoto] upn passed into function was null, empty, or undefined.");
        }

        var peoplePhotoApiUrl = `${process.env.REACT_APP_GRAPH_API}users/${upn}/photo/$value`;
        var scope = process.env.REACT_APP_GRAPH_API_SCOPE;
        var token = await getToken(instance, scope);
        return fetch(peoplePhotoApiUrl, {
            method: 'GET',
            headers: {
                'Cache-Control': 'no-store',
                'Authorization': 'Bearer ' + token,
                'ConsistencyLevel': 'eventual'
            }
        })
        .then(response => {
            if (response.status === 404) {
                return new Blob();
            }
            return response.blob();
        })
            .then((resultBytes) => {
                var reader = new FileReader();
                reader.readAsDataURL(resultBytes);
                return new Promise<string>((resolve, reject) => {
                    reader.onloadend = function () {
                        var base64data = reader.result;
                        if (!base64data?.toString().includes("image/jpeg")) {
                            base64data = defaultAvatar;
                        }
                        resolve(base64data as string);
                    };
                });
            });
    } catch (error) {
        console.log(`An error occurred while trying to fetch the image for: ${upn}. The error is: ${error}`);
        throw error;
    }
}